export default function ViewTabs({ value, onChange, items }) {
  return (
    <div className="view-tabs" role="tablist">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={value === item.id}
          className={value === item.id ? 'view-tab on' : 'view-tab'}
          onClick={() => onChange(item.id)}
        >
          {item.label}
          {item.hint != null ? <em>{item.hint}</em> : null}
        </button>
      ))}
    </div>
  );
}
